import React from 'react';

function WebSiteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="101"
      fill="none"
      viewBox="0 0 101 101"
    >
      <g clipPath="url(#clip0_1283_3061)">
        <path
          fill="#6754E2"
          d="M50.447.212C22.854.242.5 22.618.5 50.212c0 27.614 22.386 50 50 50s50-22.386 50-50a49.992 49.992 0 00-4.758-21.148l-.045.039-2.674 2.673 2.616 12.264c.263 2.407-.204 3.345-1.211 5.03-2.291 2.366-5.044 2.742-7.47 1.438l-5.198-2.796h-2.207c-.016-.488-.043-.971-.067-1.455l-3.528-1.93-1.526.916c.053.817.097 1.64.127 2.469h-5.08l-4.26 2.555c-1.41.846-3.043 1.11-4.729.896-2.148-.58-3.364-1.843-3.969-3.451H53v-16.63h4.406L48 21.414v4.666H31.25c.988-2.823 2.13-5.43 3.408-7.75C38.39 11.553 43.071 7.314 48 6.092v9.635c.99-1.692 2.865-2.534 5-2.985V5.894c3.39.576 6.682 2.587 9.656 5.86l2.25-.32 3.744-7.808A50 50 0 0050.5.212h-.053zM36.48 7.444c-2.324 2.352-4.41 5.22-6.203 8.475-1.68 3.05-3.125 6.467-4.312 10.162H12.51c5.535-8.706 13.975-15.37 23.97-18.637zM9.756 31.082h14.808c-1.245 5.162-2.008 10.76-2.203 16.63H5.572a44.796 44.796 0 014.184-16.63zm19.974 0H48v16.63H27.367c.212-5.935 1.043-11.554 2.363-16.63zM5.572 52.712h16.762c.129 5.856.82 11.454 1.994 16.63H9.756a44.79 44.79 0 01-4.184-16.63zm21.762 0H48v16.63H29.48c-1.245-5.1-2.006-10.715-2.146-16.63zm25.666 0h21.592c-.14 5.915-.902 11.53-2.147 16.63H53v-16.63zm26.576 0h15.852a44.79 44.79 0 01-4.184 16.63H77.59c1.17-5.177 1.857-10.775 1.986-16.63zM12.51 74.342h13.136c1.242 4.085 2.8 7.84 4.631 11.165 1.438 2.61 3.068 4.969 4.854 7.017-9.407-3.41-17.336-9.87-22.621-18.182zm18.394 0H48V95.14c-.308-.017-.612-.048-.918-.07-4.59-1.5-8.924-5.62-12.424-11.975-1.428-2.594-2.692-5.538-3.754-8.753zm22.096 0h18.021c-1.06 3.216-2.325 6.159-3.753 8.753-3.428 6.225-7.656 10.308-12.141 11.883-.708.07-1.417.125-2.127.162V74.342zm23.275 0H88.49a45.06 45.06 0 01-21.228 17.64c1.604-1.92 3.075-4.093 4.386-6.475 1.831-3.325 3.388-7.081 4.627-11.165z"
        ></path>
        <path
          fill="#C9C2F5"
          d="M75.833.212a1.5 1.5 0 00-1.363.836l-6.814 13.809-15.239 2.213a1.5 1.5 0 00-.83 2.558l11.026 10.748-2.602 15.178a1.5 1.5 0 002.176 1.58l13.63-7.164 13.628 7.164a1.5 1.5 0 002.177-1.58L89.02 30.376l11.027-10.748a1.495 1.495 0 00.379-1.538 1.499 1.499 0 00-1.21-1.02l-15.239-2.213-6.815-13.809a1.5 1.5 0 00-1.328-.836z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1283_3061">
          <path
            fill="#fff"
            d="M0 0H100V100H0z"
            transform="translate(.5 .212)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}
export default WebSiteIcon;
